import { useCallback } from 'react';

import { useAddItemFromTemplate } from 'react-hooks';

import {
  buildUnhideQuestionParams,
  type UnhideQuestionInput,
} from './buildUnhideQuestionParams';
import type { MutationContext } from './mutationLane';

export type UnhideQuestion = (
  input: UnhideQuestionInput,
  context: MutationContext
) => Promise<number>;

// `context.baseVersion` is not sent yet: it is the hook point for the
// expected version (TS-55794)
export function useUnhideQuestion(): UnhideQuestion {
  const { addItemFromTemplate } = useAddItemFromTemplate();

  return useCallback<UnhideQuestion>(
    async input => {
      const params = buildUnhideQuestionParams(input);
      const { newVersion } = await addItemFromTemplate(params);

      return newVersion;
    },
    [addItemFromTemplate]
  );
}
